import { APPS2_SUCCESS } from 'app/actions/apps/apps';
// import { APP_SUBSCRIBE_SUCCESS } from 'app/actions/apps/subscribe';


const defaultState = {
  // данные пакетов тарифов
  // [id]: {}
  // ...
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case APPS2_SUCCESS: {
      return { ...action.payload.tariffBundles };
    }
    // case APP_SUBSCRIBE_SUCCESS: {
    //   return { ...state, ...action.payload.tariffBundles };
    // }
    default:
  }

  return state;
}
